declare global {
    interface Window {
      // analytics object getting binding as a global variable to the window object
      dataLayer: any;
    }
  }
  export {};
  

export const getStaticAssetPath = (path: string): string => {
    return '/ecom-int' + path;
};
